import { post } from './axios.js';

//授权登录
export const loginOauth = (params) => {
  return post('api/operating/oauth', 'loginOauth', params);
}
//日志管理---微信网关消息查询
export const queryWeChatRequest = (params) => {
  return post('api/logs/logquery', 'WechatRequest', params);
}
//【日志管理-日志记录查询】
export const queryLogList = (params) => {
  return post('api/logs/logquery', 'LogRecord', params);
}
//【日志管理-缓存Key查询】
export const querySessionKey = (params) => {
  return post('api/logs/logquery', 'CacheKey', params);
}
//日志管理-数据库日志查询
export const querySqlNoramlLog = (params) => {
  return post('api/logs/logquery', 'SQLNormal', params);
}
//日志管理-数据库异常日志查询
export const querySqlExceptionLog = (params) => {
  return post('api/logs/logquery', 'SQLException', params);
}
//日志管理-API请求查询
export const queryAPIActionNormal = (params) => {
  return post('api/logs/logquery', 'ActionNormal', params)
}
//日志管理-API异常请求查询
export const queryAPIActionException = (params) => {
  return post('api/logs/logquery', 'ActionException', params)
}
//日志管理-api请求日志树
export const GetLogTree = (params) => {
  return post('api/logs/logquery', 'GetLogTree', params)
}
//服务商管理-服务商列表
export const queryCorpList = (params) => {
  return post('api/gateway/corp', 'GetList', params);
}
//服务商管理 -编辑服务商
export const editServiceCorp = (params) => {
  return post('api/gateway/corp', 'UpdateCorp', params);
}
//服务管理 -新增服务商
export const addServiceCorp = (params) => {
  return post('api/gateway/corp', 'AddCorp', params);
}
// 服务管理 - 设置服务商头像
export const setServiceAvatar = (params) => {
  return post('api/gateway/corp', 'SetCorpAvatar', params);
}
//服务商管理 - 服务列表
export const queryServiceList = (params) => {
  return post('api/gateway/corpservice', 'GetList', params);
}
//服务商管理New - 服务列表
// export const queryServiceList = (params) => {
//   return post('api/gateway/corpservice', 'GetCorpServiceList', params);
// }
//用户查询-B端用户
export const GetmerchantsuserList = (params) => {
  return post('api/merchants/merchantsuser', 'GetList', params)
}
//用户查询-C端用户/api/user/userinfo
export const GetuserinfoList = (params) => {
  return post('api/user/userinfo', 'GetList', params);
}
//合作商管理-应用列表
export const GetmerchantsinfoList = (params) => {
  return post('api/merchants/merchantsinfo', 'GetPageList', params);
}
export const saveAppInfo = (params) => {
  return post('api/merchants/merchantsinfo', 'SaveAppInfo', [params]);
}
export const getAppProducts = (params) => {
  return post('api/merchants/merchantsinfo', 'GetAppProducts', params);
}
export const addAppProduct = (params) => {
  return post('api/merchants/merchantsinfo', 'AddAppProduct', [params]);
}
export const enableAppProduct = (params) => {
  return post('api/merchants/merchantsinfo', 'EnableAppProduct', [params]);
}
export const removeAppProduct = (params) => {
  return post('api/merchants/merchantsinfo', 'RemoveAppProduct', params);
}
export const updateAppProductName = (params) => {
  return post('api/merchants/merchantsinfo', 'UpdateAppProductName', params);
}
export const getPageRelations = (params) => {
  return post('api/merchants/merchantsinfo', 'GetPageRelations', [params]);
}
export const getAdminList = (params) => {
  return post('/api/merchants/merchantsuser', 'GetList', [params]);
}
export const getJoinedApps = (params) => {
  return post('api/merchants/merchantsinfo', 'GetJoinedApps', params);
}
export const getPageRelationsWithoutSelf = (params) => {
  return post('api/merchants/merchantsinfo', 'GetPageRelationsWithoutSelf', params);
}
export const getMerchantsInfo = (params) => {
  return post('api/merchants/merchantsinfo', 'GetMerchantsInfo', [params]);
}
//角色权限
export const getPermissionRoleList = (params) => {
  return post('api/merchants/merchantspermission', 'GetRoleList', [params]);
}


//合作商管理-合作商列表
export const GetmerchantscorpList = (params) => {
  return post('api/merchants/merchantscorp', 'GetList', params);
}
// 创建合作商
export const AddCorp = (params) => {
  return post('api/merchants/merchantscorp', 'AddCorp', params);
}
// 修改合作商信息（部分属性）
export const UpdateCorp = (params) => {
  return post('api/merchants/merchantscorp', 'UpdateCorp', params);
}
export const enableProduct = (params) => {
  return post('api/merchants/merchantscorp', 'EnableProduct', params);
}
export const removeProduct = (params) => {
  return post('api/merchants/merchantscorp', 'RemoveProduct', params);
}
// // 重置合作商密码
export const ResetPwd = (params) => {
  return post('api/merchants/merchantscorp', 'ResetPwd', params);
}
//跳转合作商详情界面或者关联界面
export const GetCorpDetail = (params) => {
  return post('api/merchants/merchantscorp', 'Get', params);
};
//设置合作商头像
export const SetCorpAvatar = (params) => {
  return post('api/merchants/merchantscorp', 'SetCorpAvatar', params);
}
export const GetCorpById = (params) => {
  return post('api/merchants/merchantscorp', 'GetCorpById', params);
}

//系统设置-角色权限
//获取角色集合
export const getRoleList = (params) => {
  return post('api/operating/role', 'getRoleList', params);
}
//获取角色对应的用户
export const getUserByRoleId = (params) => {
  return post('api/operating/role', 'getRoleUserDetail', params);
}
//获取角色对应菜单
export const getMenuByRoleId = (params) => {
  return post('api/operating/role', 'getRoleMenuDetail', params);
}
// 编辑角色对应菜单
export const editRoleMenu = (params) => {
  return post('api/operating/role', 'editRoleMenu', params)
}
//编辑角色对应的人员
export const editRoleUser = (params) => {
  return post('api/operating/role', 'editRoleUser', params)
}
//删除角色
export const deleteRole = (params) => {
  return post('api/operating/role', 'deleteRole', params)
}
//编辑角色
export const editRole = (params) => {
  return post('api/operating/role', 'editRole', params);
}

//系统设置-通讯录
export const getDepUser = () => {
  return post('api/operating/department', 'getDepUser');
}
//获取菜单
export const getMenuList = () => {
  return post('api/operating/menu', 'getMenuList');
}
//1.合作商&应用&B端用户统计
//获取B端用户增长信息
export const getBUserGrowth = (params) => {
  return post('api/merchants/statistics', 'GetUserGrowth', params);
}
//获取应用增长信息
export const getAppGrowth = (params) => {
  return post('api/merchants/statistics', 'GetAppGrowth', params);
}
//汇总信息 应用总数 合作商总数 B端用户总数
export const getAppSummary = (params) => {
  return post('api/merchants/statistics', 'GetSummaryInfo', params);
}
//获取C端用户信息
export const getCUserGrowth = (params) => {
  return post('api/user/statistics', 'GetUserGrowth', params);
}
//获取C端汇总信息
export const getCSummary = () => {
  return post('api/user/statistics', 'GetSummaryInfo');
}
//获取服务商汇总
export const getServiceSummary = () => {
  return post('api/gateway/statistics', 'GetSummaryInfo');
}
// 服务增长
export const getServiceGrowth = (params) => {
  return post('api/gateway/statistics', 'GetServiceGrowth', params);
}
// 合作商排行榜
export const getCorpListTop = (params) => {
  return post('api/merchants/statistics', 'GetCorpList', params);
}
// 获取用户详情
export const getUserDetail = (params) => {
  return post('api/operating/user', 'getUserDetail', params);
}

// 获取产品列表
export const getProducts = () => {
  return post('api/merchants/merchantsinfo', 'GetProducts');
}
// 获取产品列表
export const getProductsByCorpId = (params) => {
  return post('api/merchants/merchantsinfo', 'GetProductsByCorpId', params);
}

//保存产品信息
export const saveProduct = (params) => {
  return post('api/merchants/merchantsinfo', 'SaveProduct', params);
}

// 获取C端用户应用映射集合
export const GetUserMapList = (params) => {
  return post('api/user/userinfo', 'GetUserMapList', params);
}
// 获取B端用户登陆APP
export const GetApps = (params) => {
  return post('api/merchants/merchantsuser', 'GetApps', params);
}
// c端用户用户排行榜
export const getAppUsers = (params) => {
  return post('api/user/statistics', 'GetAppUsers', params);
}
//获取模块配置列表
export const moduleConfigList = (params) => {
  return post('api/config/module', 'GetList', params);
}
//更新Module配置
export const getModuleConfig = (params) => {
  return post('api/config/module', 'Get', params);
}
//更新Module配置
export const updateModuleConfig = (params) => {
  return post('api/config/module', 'Get', params);
}
//删除Module配置
export const deleteModuleConfig = (params) => {
  return post('api/config/module', 'Delete', params)
}

// 获取合作商配置列表
export const corpConfigList = (params) => {
  return post('api/config/corp', 'GetList', params);
}
export const updateCorpConfig = (params) => {
  return post('api/config/corp', 'Get', params);
}
export const deleteCorpConfig = (params) => {
  return post('api/config/corp', 'Delete', params);
}

// 获取菜单列表
export const getMenus = (params) => {
  return post('api/merchants/merchantsinfo', 'GetMenus', params)
}

//保存菜单设置
export const setMenu = (params) => {
  return post('api/merchants/merchantsinfo', 'SetMenu', params)
}

//查询产品
export const getProductById = (params) => {
  return post('api/merchants/merchantsinfo', 'GetProductById', params)
}

/**
 * 应用类型 病种数量 医院数量
 */
export const getAppTypeList = () => {
  return post('api/merchants/merchantsinfo', 'GetAppTypes')
}

export const getDoc = (method, params) => {
  return post('api/doc/doc', method, params);
}

// 获取区块链申请列表
export const getBlockApplyList = (method, params) => {
  return post('api/operating/block', method, [params])
}

export const getAppTypes = () => {
  return post('api/merchants/statistics', 'GetAppTypes')
}
export const getALlianceTree = () => {
  return post('api/merchants/statistics', 'GetAllianceTree')
}
export const getLogSoarequestRecord = (params) => {
  return post('api/logs/logquery', 'LogSoarequestRecord', [params])
}
export const setLogin = (params) => {
  return post('api/system/user', 'Login', [params])
}





// WEBPACK FOOTER //
// ./src/api.js